import { Alert, AlertTitle, Box, Stack, Typography } from "@mui/material";

// Standing per-date audit of part-allocated residents (have a room but a gap
// somewhere in their stay). Read-only — there's no single action to undo, it's
// just surfacing who needs attention. Recomputed from the resident feed, so it
// refreshes whenever the date changes.
function BedroomGapsPanel({ gaps }) {
  if (!gaps || gaps.length === 0) return null;

  return (
    <Box sx={{ width: "100%", mb: 2 }}>
      <Alert severity="warning" variant="outlined">
        <AlertTitle>
          {gaps.length} resident{gaps.length === 1 ? "" : "s"} with bedroom gaps
        </AlertTitle>
        <Stack spacing={0.5}>
          {gaps.map((g) => (
            <Typography key={g.residentId} variant="body2">
              <strong>{g.name}</strong> — {g.messages.join(" ")}
            </Typography>
          ))}
        </Stack>
      </Alert>
    </Box>
  );
}

export default BedroomGapsPanel;
